  
  const initCollectionBreadcrumbs = () => {

    const breadcrumbContainer = document.querySelector('.collection-breadcrumbs-container');
    if (!breadcrumbContainer) {
      console.warn('Breadcrumb container not found');
      return;
    }

    const isFromSearch = location.search.includes('_sid=');
    if (!isFromSearch){
      return;
    }

    breadcrumbContainer.classList.remove('u-hidden');

    const searchBreadcrumb = breadcrumbContainer.querySelector('.breadcrumb__item--search');
    if (!searchBreadcrumb){
      console.warn('Search breadcrumb not found');
      return;
    }

    searchBreadcrumb.classList.remove('u-hidden');

    const recentSearchesJson = localStorage.getItem('recentSearches');
    let recentSearches = [];
    try {
      recentSearches = JSON.parse(recentSearchesJson) || [];
    } catch (e) {
      console.error('Error parsing recent searches from localStorage', e);
    }

    const mostRecentSearch = recentSearches.length > 0 ? recentSearches[recentSearches.length - 1] : null;
    const searchLink = searchBreadcrumb.querySelector('a');
    if (!searchLink){
      console.warn('No search link found in breadcrumbs');
      return;
    }

    if (mostRecentSearch) {
      searchLink.href = mostRecentSearch.uri;
      searchLink.textContent = `${searchLink.textContent}: ${mostRecentSearch.query}`;
    } else {
      searchLink.href = '#';
    }
};

initCollectionBreadcrumbs();